// Reemplaza los patrones '%s' por los valores indicados
export const format = (text: string, ...replaceValues: (string | number)[]) => {
  for (const replaceValue of replaceValues)
    text = text.replace('%s', replaceValue.toString());
  return text;
};

// Convierte la primera letra a mayúscula
const firstLetterRegex = /(?<=^|¡|!|¿|\?)[a-zA-ZáÁéÉíÍóÓúÚüÜñÑ]/;
export const firstLetterUppercase = (text: string) => {
  const match = text.match(firstLetterRegex);
  if (!match)
    return text;
  return text.replace(firstLetterRegex, match[0].toUpperCase());
};
